
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'
import ButtonIcon from '../molecules/ButtonIcon.vue'
import AppButton from '../atoms/AppButton.vue'
import { Contents } from '@/data/@types/MyCollectionContents'
import { MyCollectionItem } from '@/data/@types/MyCollectionItem'
import TheLoginForm from '@/components/organisms/TheLoginForm.vue'
import ModalWindow from '@/components/organisms/ModalWindow.vue'

export default defineComponent({
  components: {
    ButtonIcon,
    TheLoginForm,
    ModalWindow,
    AppButton,
  },
  props: {
    pid: String,
    bid: {
      type: [String, Boolean],
      default: false
    },
    cid: {
      type: [String, Boolean],
      default: false
    },
    isContentDetailPageHeader: {
      type: Boolean,
      default: false
    },
    isContentDetailPageToolbar: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const ICON_STYLE_BOOKMARK_FILL = 'bookmark-fill'
    const ICON_STYLE_BOOKMARK = 'bookmark'

    const store = useStore()

    const isAnnotationModalShow = ref<boolean>(false)
    const isLogoutModalShow = ref<boolean>(false)

    const addRemoveList = () => {
      store.dispatch('myCollectionAddRemoveList', {
        pid: props.pid,
        bid: props.bid || null,
        cid: props.cid || null
      })
    }

    const itemLink = () => {
      store.dispatch('myCollectionItemLink', {
        tagId: 0,
        pid: props.pid,
        bid: props.bid || null,
        cid: props.cid || null
      })
    }

    const matchContentId = (content: any) => {
      return props.bid === content.bid && props.cid === content.cid
    }

    const matchPid = (item: MyCollectionItem) => {
      if (props.bid && props.cid) {
        const contents:Contents[] = item.contents || []
        if (!contents.length) return false

        if (Number(props.pid) === item.pid) {
          return contents.filter(matchContentId).length > 0
        }
      }

      return Number(props.pid) === item.pid
    }

    const isLoggedIn = computed(() => {
      return store.getters.isLoggedIn || false
    })

    const bookmarkButtonStyle = computed(() => {
      if (isLoggedIn.value) return 'logged-in'
      if (props.isContentDetailPageToolbar) return 'has-form-label'
      if (props.isContentDetailPageHeader) return 'title'
      else return 'has-text-thin'
    })

    const isBookmark = computed(() => {
      if (!isLoggedIn.value) return false
      const list = store.getters.myCollectionList
      const match = list.filter(matchPid)
      return match.length > 0
    })

    const onLogin = () => {
      if (!isBookmark.value) itemLink()
      isLogoutModalShow.value = false
    }

    const onBookmarkItem = () => {
      if (!isLoggedIn.value) {
        isAnnotationModalShow.value = !isAnnotationModalShow.value
        return
      }

      if (isBookmark.value) { // 削除
        addRemoveList()
      } else { // 追加
        itemLink()
      }
    }

    const bookmarked = ref(isBookmark)

    return {
      ICON_STYLE_BOOKMARK_FILL,
      ICON_STYLE_BOOKMARK,
      onBookmarkItem,
      onLogin,
      bookmarked,
      isBookmark,
      isLoggedIn,
      isAnnotationModalShow,
      isLogoutModalShow,
      bookmarkButtonStyle,
    }
  }
})
